import Vue from "vue";
import Vuex from "vuex";

// import projectStore from './modules/project-store';
// import tradeStore from './modules/trade-store';
// import userStore from './modules/user-store';
// import stateStore from './modules/state-store';
// import modelStore from './modules/model-store';
import * as types from "./actionType/state-type";

Vue.use(Vuex);

const state = {
  requesting: false,
  result: {},
  //   businessTitle: "",
  //   firstId: "",
  //   secondId: ""
  business: {},
  searchVuex:''
};

const getters = {
  requesting: state => state.requesting,
  result: state => state.result,
  business: state => state.business,
  searchVuex: state => state.searchVuex
  //   businessTitle: state => state.businessTitle,
  //   firstId: state => state.firstId,
  //   secondId: state => state.secondId
};

const actions = {
  prompt({ commit, state }, result) {
    commit(types.RETURN_RESULT, result);
  },
  setTitle({ commit, state }, business) {
    commit("setTitle", business);
  },
  setSearch({ commit, state }, data) {
    commit("setSearch", data);
  },
};

const mutations = {
  setTitle(state, business) {
    state.business = business;
  },
  setSearch(state, data) {
    state.searchVuex = data;
  },
  [types.REQUESTING]: (state, data) => {
    state.requesting = data;
  }
};

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  actions,
  mutations,
  modules: {
    // projectStore,
    // tradeStore,
    // userStore,
    // stateStore,
    // modelStore
  }
});

export { store };



// WEBPACK FOOTER //
// ./src/vuex/index.js